export const PaymentType = {
	"CREDIT_CARD": 1,
	"APPLE_PAY": 2,
	"GOOGLE_PAY": 3,
	"CASH": 4,
	"BUSINESS_BILLING": 5,
	"IN_ROOM_BILLING": 6
}